import { useEffect, useState, useCallback, useMemo } from "react";
import { useRouter } from "next/router";
import withMiddlewares from "@/middlewares/withMiddlewares";
import SearchPageMetaTags, {
  tags,
} from "@/components/MetaTags/SearchPageMetaTags";
import SearchResult from "@/components/SearchResult";
import DropdownSelect from "@/components/DropdownSelect";
import { useBreadcrumbs } from "@/hooks";
import { searchSort, searchTvShowSort } from "@/lib/sorts";
import contentsStyles from "@/styles/Contents.module.scss";
import routes from "@/lib/routes";
import config from "@/lib/config";
import { SEARCH_CONFIG } from "@/apollo/queries/searchConfig";

function isValidPath(targetPath) {
  const paths = ["valueplan", "channel", "store", "live"];
  return paths
    .filter((path) => {
      return true;
    })
    .includes(targetPath);
}

export default function SearchDetail() {
  const router = useRouter();
  const path = router?.query?.path;
  const searchQuery = router?.query?.q;
  const { setBreadcrumbs } = useBreadcrumbs();
  const sorts = useMemo(() => {
    if (path === "valueplan") {
      return searchTvShowSort;
    } else {
      return searchSort;
    }
  }, [path]);
  const [sort, setSort] = useState(sorts[0].value);

  const searchResultTitles = useMemo(() => {
    return {
      valueplan: config.valuePlan.text,
      channel: "月額商品",
      store: "単品商品",
      live: "ライブ",
    };
  }, []);

  const handleSelect = useCallback((selectedSort) => {
    setSort(selectedSort.value);
  }, []);

  useEffect(() => {
    setBreadcrumbs([
      { text: "ホーム", href: routes.home },
      { text: "検索結果", href: routes.search(searchQuery) },
      { text: searchResultTitles[path] },
    ]);
  }, [path, searchQuery]);

  return (
    <>
      <SearchPageMetaTags keyword={searchQuery} mode={path} />
      <div className={contentsStyles.container}>
        <header>
          <h1>
            {searchResultTitles[path]} "{searchQuery}"の検索結果
          </h1>
        </header>
        <nav className={contentsStyles.withSort}>
          <div></div>
          <DropdownSelect
            right
            options={sorts}
            onSelect={handleSelect}
            className="sort"
          />
        </nav>
        <SearchResult mode={path} searchQuery={searchQuery} sort={sort} />
      </div>
    </>
  );
}

export const getServerSideProps = withMiddlewares(
  async ({ req, query }, { serverProps, error, apolloClient }) => {
    await apolloClient.query({
      query: SEARCH_CONFIG,
      fetchPolicy: "cache-first",
    });
    const path = query.path;
    if (!isValidPath(path)) {
      return {
        notFound: true,
      };
    }
    const metatags = tags(query.q, path);
    return {
      props: {
        ...serverProps,
        metatags,
        error,
        initialApolloState: apolloClient.cache.extract(),
      },
    };
  }
);
